"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _PaymentBridge = _interopRequireDefault(require("../PaymentBridge"));
var _LoadingView = _interopRequireDefault(require("../LoadingView"));
var _pricing = require("../helpers/pricing");
var _querystring = require("../helpers/querystring");
var _booking = require("../actions/booking");
var _newComponents = require("../new-components");
var _PaymentSuccess = _interopRequireDefault(require("../new-components/PaymentSuccess/PaymentSuccess"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ExtrasCheckout = /*#__PURE__*/function (_Component) {
  function ExtrasCheckout(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ExtrasCheckout);
    _this = _callSuper(this, ExtrasCheckout, [props]);
    _this.state = {
      order: null
    };
    _this.componentDidMount = _this.componentDidMount.bind(_this);
    _this.handleSuccess = _this.handleSuccess.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    _this.cancelOrder = _this.cancelOrder.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ExtrasCheckout, _Component);
  return (0, _createClass2["default"])(ExtrasCheckout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        booking = _this$props.booking,
        productVariants = _this$props.productVariants;
      if (!this.state.order) {
        var query = (0, _querystring.getQuery)(window.location);
        if (query.order) {
          this.fetchOrder(query.order);
        } else {
          this.createOrder(booking, productVariants);
        }
      }
    }
  }, {
    key: "fetchOrder",
    value: function () {
      var _fetchOrder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(orderId) {
        var response, order;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _booking.getExtrasOrder)(orderId);
            case 2:
              response = _context.sent;
              if (response.status === 'success') {
                order = response.data;
                this.setState({
                  order: order
                });
                this.props.setOrderToParentState(order);
              } else {
                this.props.onFailure(response.message);
                this.redirectBack();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOrder(_x) {
        return _fetchOrder.apply(this, arguments);
      }
      return fetchOrder;
    }()
  }, {
    key: "createOrder",
    value: function () {
      var _createOrder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(booking, productVariants) {
        var response, order;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _booking.createExtrasOrder)(booking, productVariants);
            case 2:
              response = _context2.sent;
              if (response.status === 'success') {
                order = response.data.order;
                this.setState({
                  order: order
                });
                this.props.setOrderToParentState(order);
              } else {
                this.props.onFailure(response.message);
                this.redirectBack();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createOrder(_x2, _x3) {
        return _createOrder.apply(this, arguments);
      }
      return createOrder;
    }()
  }, {
    key: "redirectBack",
    value: function redirectBack() {
      var _this$props2 = this.props,
        location = _this$props2.location,
        match = _this$props2.match,
        history = _this$props2.history;
      var index = location.pathname.indexOf('/checkout');
      history.push("".concat(match.url.substring(0, index)));
    }
  }, {
    key: "cancelOrder",
    value: function () {
      var _cancelOrder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var booking, order, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              booking = this.props.booking;
              order = this.state.order;
              if (!order) {
                _context3.next = 7;
                break;
              }
              _context3.next = 5;
              return (0, _booking.cancelExtrasOrder)(order, booking);
            case 5:
              response = _context3.sent;
              if (response.status === 'success') {
                this.redirectBack();
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function cancelOrder() {
        return _cancelOrder.apply(this, arguments);
      }
      return cancelOrder;
    }()
  }, {
    key: "handleSuccess",
    value: function handleSuccess(payment) {
      var paidOrder = _objectSpread(_objectSpread({}, this.state.order), {}, {
        status: 'paid'
      });
      this.props.setOrderToParentState(paidOrder);
      this.props.getCrewMembers(this.props.booking.id);
      this.setState({
        success: true,
        order: paidOrder,
        payment: {
          status: payment.status,
          datePaid: payment.datePaid,
          method: payment.method,
          amountPaid: payment.amountPaid,
          currencyPaid: payment.currencyPaid
        }
      });
    }
  }, {
    key: "handleError",
    value: function handleError() {
      this.setState({
        error: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _booking$week, _order$orderItems$0$p;
      var _this$state = this.state,
        order = _this$state.order,
        success = _this$state.success,
        error = _this$state.error,
        payment = _this$state.payment;
      // const singleItem = order && order.orderItems[0];
      var _this$props3 = this.props,
        booking = _this$props3.booking,
        visa = _this$props3.visa,
        mastercard = _this$props3.mastercard,
        amex = _this$props3.amex,
        product = _this$props3.product,
        baseUrl = _this$props3.baseUrl,
        companyId = _this$props3.companyId;
      if (!order) {
        return /*#__PURE__*/_react["default"].createElement(_LoadingView["default"], {
          title: "Opening the checkout.."
        });
      }
      if (success) {
        return /*#__PURE__*/_react["default"].createElement(_PaymentSuccess["default"], {
          payment: payment
        });
      }
      var formattedAmount = (0, _pricing.formatCurrency)(order.gross / 100, order.currency);
      var bookingDate = _moment["default"].utc(booking.createdAt);
      var launchDate = _moment["default"].utc('2023-07-18').set({
        hour: 11,
        minute: 0,
        second: 0
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-component"
      }, !!order && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-md"
      }, "Order:"), order.orderItems.map(function (item, i) {
        return console.log({
          item: item
        }) || /*#__PURE__*/_react["default"].createElement("div", {
          key: i,
          className: "flex justify-between d8-u-text-bold text-sm"
        }, /*#__PURE__*/_react["default"].createElement("span", null, item.quantity, " x ", item.productVariant.name), /*#__PURE__*/_react["default"].createElement("span", null, (0, _pricing.formatCurrency)(item.gross / 100, order.currency)));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between d8-u-text-bold text-md margin-top-md"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Total:"), /*#__PURE__*/_react["default"].createElement("span", null, formattedAmount))), error && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Uh oh. Error \uD83D\uDE22."), error), /*#__PURE__*/_react["default"].createElement("hr", {
        className: "full-width margin-y-lg border d8-u-radius-md"
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_PaymentBridge["default"], {
        bookingId: booking.id,
        orderId: order.id,
        registeredAmount: order.gross,
        paidAmount: order.gross,
        currency: order.currency,
        amountString: "".concat(formattedAmount),
        createPayment: this.props.createPayment,
        checkPaymentInfo: this.props.checkPaymentInfo,
        onPaymentSuccess: this.handleSuccess,
        onError: this.handleError,
        visa: visa,
        mastercard: mastercard,
        amex: amex,
        product: product,
        baseUrl: baseUrl,
        companyId: companyId,
        weekTerms: booking === null || booking === void 0 || (_booking$week = booking.week) === null || _booking$week === void 0 ? void 0 : _booking$week.extraTermsUrl,
        skipCardCharges: bookingDate.isBefore(launchDate) || !((_order$orderItems$0$p = order.orderItems[0].productVariant) !== null && _order$orderItems$0$p !== void 0 && _order$orderItems$0$p.applyFees)
      }), /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        className: "margin-top-md",
        text: "Cancel",
        onClick: this.cancelOrder,
        buttonType: _newComponents.BUTTON_TYPES.ERROR,
        fullWidth: true
      })));
    }
  }]);
}(_react.Component);
ExtrasCheckout.propTypes = {
  booking: _propTypes["default"].object.isRequired,
  productVariants: _propTypes["default"].array,
  createPayment: _propTypes["default"].func.isRequired,
  checkPaymentInfo: _propTypes["default"].func.isRequired,
  getCrewMembers: _propTypes["default"].func.isRequired,
  location: _propTypes["default"].object.isRequired,
  match: _propTypes["default"].object.isRequired,
  history: _propTypes["default"].object.isRequired,
  amex: _propTypes["default"].bool,
  visa: _propTypes["default"].bool,
  mastercard: _propTypes["default"].bool,
  onFailure: _propTypes["default"].func,
  product: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string,
  setOrderToParentState: _propTypes["default"].func.isRequired,
  companyId: _propTypes["default"].number
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    createPayment: _booking.createPayment,
    getCrewMembers: _booking.getCrewMembers,
    checkPaymentInfo: _booking.checkPaymentInfo
  }, dispatch);
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactRouterDom.withRouter)(ExtrasCheckout));